export default {
    methods: {
        copy(notes) {
            notes = notes.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
            if (navigator.clipboard) {
                navigator.clipboard.writeText(notes)
                .then(() => {
                    this.copySuccess()
                })
                .catch((error) => {
                    console.log(error)
                    this.copyFailure()
                })
            }
            else {
                var textArea = document.createElement('textarea')
                textArea.style.display = 'none'
                textArea.value = notes
                document.body.appendChild(textArea)
                textArea.focus()
                textArea.select()

                try {
                    var successful = document.execCommand('copy')
                    if (successful)
                        this.copySuccess()
                }
                catch (err) {
                    this.copyFailure()
                }
                document.body.removeChild(textArea)
                return
            }
        },
        copySuccess() {
            this.$message({
                message: 'Notes copied to clipboard',
                type: 'success'
            });
        },
        copyFailure() {
            console.log('error')
        },
    }
}
